import {Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges} from '@angular/core';

@Directive({
  standalone: false,
  selector: '[tooltip]'
})
export class TooltipDirective implements OnChanges {
  @Input('tooltip') tooltipText: string;

  constructor(private el: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.tooltipText) {
      this.renderer.setAttribute(this.el.nativeElement, 'title', this.tooltipText || '');
    }
  }
}